<template>
  <div class="empty flex-col-center" :style="pcModuleBackColor">
    <img
      v-lazy="require(`@/assets/images/common/tips/no-data.png`)"
      alt="no data"
      class="no-data"
    />
    <p class="tips" :style="mFontColor">{{ $t('coupon.noData') }}</p>
  </div>
</template>
<script>
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  export default {
    mixins: [styleConfiguration],
    data() {
      return {}
    },
  }
</script>
<style lang="scss" scoped src="./Empty_pc.scss"></style>
